import { Link } from "react-router-dom";
import { useLanguage } from "../context/LanguageContext";
import translations from "../i18n/translations";
import { Mail, Phone, MapPin, Instagram } from "lucide-react";

export default function Footer() {
  const { lang } = useLanguage();
  const text = translations[lang].footer;

  return (
    <footer className="border-t mt-16 bg-white">
      <div className="max-w-6xl mx-auto px-6 py-10 flex flex-col md:flex-row justify-between gap-10">
        
        {/* LEFT */}
        <div>
          <div className="hdr-title text-2xl">HelvetAssist</div>
          <div className="muted mt-2">{text.tagline}</div>

          {/* Instagram */}
          <a
            href="https://www.instagram.com/helvet.assist/"
            target="_blank"
            rel="noreferrer"
            className="flex items-center gap-2 mt-4 text-gray-600 hover:text-red-600 transition"
          >
            <Instagram size={20} />
            <span>HelvetAssist</span>
          </a>
        </div>

        {/* RIGHT */}
        <div className="flex flex-col sm:flex-row gap-10">

          {/* SERVICES */}
          <div>
            <div className="text-sm muted">{text.services}</div>
            <ul className="mt-2">
              <li>
                <Link to="/services" className="muted hover:text-slate-900">
                  {text.allServices}
                </Link>
              </li>
            </ul>
          </div>

          {/* CONTACT */}
          <div>
            <div className="text-sm muted">{text.contact}</div>

            <div className="mt-3 space-y-2 text-sm text-gray-600">
              
     <div className="flex items-center gap-2">
  <Mail size={16} />
  <a href="mailto:info@helvet-assist.ch" className="hover:underline">
    info@helvet-assist.ch
  </a>
</div>
<a
  href="https://wa.me/41767070557"
  target="_blank"
  rel="noopener noreferrer"
  className="flex items-center gap-2 hover:underline cursor-pointer transition"
>
  <Phone size={16} />
  <span>076 707 05 57</span>
</a>
              <div className="flex items-center gap-2">
                <MapPin size={16} />
                <span>Canton de Vaud</span>
              </div>

            </div>
          </div>

        </div>
      </div>

      <div className="text-center text-sm muted py-4 border-t">
        © {new Date().getFullYear()} HelvetAssist. {text.rights}
      </div>
    </footer>
  );
}